module.exports = __webpack_public_path__ + "img/PPMPprint4.5af6df56.png";